import React from 'react';
import { Route } from 'react-router';
export default (
  <Route
    path="DepartmentId/(:departmentId)"
    getComponent={(Location, callback) => {
      require.ensure([], (require) => {
        callback(null, require('./index'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/PeopleSearch/screens/List/screens/Department/router.js
 **/